import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/rentzeme/app/src/v3/components/property/savedListing/index.tsx");
